import type { NudgeRecommendationDetails } from '@atlassian/convo-ai-api';

// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import type { IDebugTriggers } from '../../types/debug-triggers-types';

/**
 * Simulates Convo AI nudge recommendations. When using the debug trigger, the service
 * request is skipped.
 */
export class DebugTriggers implements IDebugTriggers {
	private triggerQueue: Partial<NudgeRecommendationDetails>[] = [];

	get hasTriggers(): boolean {
		return Boolean(this.triggerQueue.length);
	}

	public addTrigger(featureId: string, featureName?: string, featureDescription?: string): void {
		this.triggerQueue.push({
			nudge_id: crypto.randomUUID(),
			feature_details: {
				feature_id: featureId,
				feature_name: featureName || 'Debug Nudge',
				feature_description: featureDescription || 'A nudge added for debugging',
			},
			cta: {
				cta_action: 'ACTION',
			},
		} as Partial<NudgeRecommendationDetails>);
	}

	public addConvoStarter(convoStarterLabel: string): void {
		this.triggerQueue.push({
			cta: {
				cta_action: 'CHAT',
				cta_label: convoStarterLabel || 'Debug Convo Starter',
			},
			nudge_id: crypto.randomUUID(),
			feature_details: {
				feature_id: 'convo-starter',
				feature_name: 'Debug Convo Starter',
				feature_description: 'A conversation starter for debugging',
			},
		} as Partial<NudgeRecommendationDetails>);
	}

	public clear(): void {
		this.triggerQueue = [];
	}

	public useNextTrigger(): Partial<NudgeRecommendationDetails> | undefined {
		return this.triggerQueue.shift();
	}
}
